import { appState } from '../state';
import { decodeAssertionOptions, encodeAssertionResponse } from '../services/webauthn';
import { applyStyle } from '../ui/css';
import { createButton } from '../ui/components/button';
import { icons } from '../ui/icons';
export function renderLogin() {
    const screen = document.createElement('div');
    applyStyle(screen, {
        minHeight: '100vh',
        width: '100%',
        background: 'radial-gradient(ellipse at top left, rgba(163,230,53,0.07), transparent 50%), '
            + 'radial-gradient(ellipse at bottom right, rgba(59,130,246,0.05), transparent 50%), '
            + 'var(--bg-base)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--sp-5)',
        fontFamily: 'var(--font-sans)',
        color: 'var(--text-primary)',
    });
    const layout = document.createElement('div');
    layout.classList.add('pr-login-layout');
    applyStyle(layout, {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 480px) minmax(0, 480px)',
        gap: 'var(--sp-7)',
        width: '100%',
        maxWidth: '1040px',
        alignItems: 'center',
    });
    // Sol — marka tanıtımı
    const brand = document.createElement('div');
    brand.classList.add('pr-login-brand');
    applyStyle(brand, {
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--sp-4)',
        minWidth: '0',
    });
    brand.innerHTML = `
    <div style="display:flex;align-items:center;gap:var(--sp-3)">
      ${icons.logo()}
      <span style="font-family:var(--font-display);font-style:italic;font-weight:500;font-size:32px">PhotonRemote</span>
    </div>
    <h1 style="margin:0;font-family:var(--font-display);font-style:italic;font-weight:500;font-size:48px;line-height:1.1;letter-spacing:-0.01em">
      Uzak masaüstü, <span style="color:var(--accent)">ışık hızında</span>.
    </h1>
    <p style="margin:0;font-size:16px;color:var(--text-secondary);max-width:420px;line-height:1.5">
      Düşük gecikmeli, uçtan uca şifreli uzak erişim. Hesabınla giriş yap; cihazların seninle gelir.
    </p>
    <ul class="pr-login-brand-list" style="list-style:none;padding:0;margin:var(--sp-4) 0 0;display:flex;flex-direction:column;gap:var(--sp-2);font-size:var(--fs-body);color:var(--text-secondary)">
      <li style="display:flex;gap:var(--sp-2);align-items:center"><span style="color:var(--accent)">✓</span> AES-256 + uçtan uca şifreleme</li>
      <li style="display:flex;gap:var(--sp-2);align-items:center"><span style="color:var(--accent)">✓</span> H.264 + Opus, &lt;30 ms gecikme</li>
      <li style="display:flex;gap:var(--sp-2);align-items:center"><span style="color:var(--accent)">✓</span> Donanım anahtarı + 2FA</li>
    </ul>
  `;
    layout.append(brand);
    // Sağ — giriş kartı
    const card = document.createElement('section');
    card.classList.add('pr-login-card');
    applyStyle(card, {
        background: 'var(--bg-elev-2)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--sp-7)',
        boxShadow: 'var(--shadow-elev)',
        minWidth: '0',
    });
    const header = document.createElement('div');
    header.innerHTML = `
    <div style="font-size:var(--fs-tiny);letter-spacing:0.16em;color:var(--text-tertiary);font-weight:500;margin-bottom:var(--sp-2)">CONTROLLER · GİRİŞ</div>
    <h2 style="margin:0;font-family:var(--font-display);font-style:italic;font-weight:500;font-size:32px;line-height:1.2">Hesabına gir</h2>
    <p style="margin:var(--sp-2) 0 0;color:var(--text-secondary);font-size:var(--fs-body)">
      E-posta ve parola ile veya donanım anahtarıyla.
    </p>
  `;
    card.append(header);
    const form = document.createElement('form');
    applyStyle(form, {
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--sp-3)',
        marginTop: 'var(--sp-5)',
    });
    form.innerHTML = `
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-caption);color:var(--text-secondary);font-weight:500;letter-spacing:0.04em">
      E-POSTA
      <input id="email" type="email" autocomplete="email"
             autocapitalize="none" autocorrect="off" spellcheck="false"
             inputmode="email" placeholder="user@example.com"
             style="padding:12px 14px;font-size:var(--fs-body);background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary)" />
    </label>
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-caption);color:var(--text-secondary);font-weight:500;letter-spacing:0.04em">
      PAROLA
      <input id="password" type="password" autocomplete="current-password"
             autocapitalize="none" autocorrect="off" spellcheck="false"
             placeholder="••••••••"
             style="padding:12px 14px;font-size:var(--fs-body);background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary)" />
    </label>
    <a id="forgot" href="#" style="font-size:var(--fs-caption);color:var(--text-link);text-align:right">
      Parolanı mı unuttun?
    </a>
  `;
    const buttonRow = document.createElement('div');
    applyStyle(buttonRow, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-2)', marginTop: 'var(--sp-3)' });
    const submit = createButton({
        label: 'Giriş yap',
        variant: 'primary',
        size: 'lg',
        fullWidth: true,
        iconHtml: icons.arrowRight(),
        iconRight: true,
    });
    submit.id = 'submit';
    const passkey = createButton({
        label: 'Donanım anahtarı / Passkey',
        variant: 'secondary',
        size: 'lg',
        fullWidth: true,
        iconHtml: icons.key(),
    });
    passkey.id = 'passkey';
    buttonRow.append(submit, passkey);
    form.append(buttonRow);
    const ssoBox = document.createElement('div');
    ssoBox.id = 'sso';
    applyStyle(ssoBox, { marginTop: 'var(--sp-4)' });
    form.append(ssoBox);
    const advanced = document.createElement('details');
    advanced.open = true;
    advanced.innerHTML = `
    <summary style="cursor:pointer;font-size:var(--fs-caption);color:var(--text-tertiary);padding:var(--sp-2) 0;list-style:none;display:flex;align-items:center;gap:6px">
      <span style="font-family:var(--font-mono);font-size:11px">▾</span>
      Sunucu adresi (gerekirse değiştir)
    </summary>
    <div style="margin-top:var(--sp-2)">
      <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-caption);color:var(--text-secondary)">
        Backend URL
        <input id="url" type="url" value="${escapeAttr(appState.backendUrl)}"
               placeholder="${appState.backendUrl ? '' : 'otomatik (vite dev proxy)'}"
               style="padding:8px 12px;font-size:var(--fs-caption);font-family:var(--font-mono);background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary)" />
      </label>
      <p style="color:var(--text-tertiary);font-size:var(--fs-tiny);margin:6px 0 0">
        Boş ise lokal dev proxy üzerinden api.photondownload.com'a yönlenir (CORS bypass).
        Farklı sunucu için tam URL gir.
      </p>
    </div>
  `;
    applyStyle(advanced, { marginTop: 'var(--sp-3)' });
    form.append(advanced);
    const errBox = document.createElement('div');
    errBox.id = 'error';
    applyStyle(errBox, {
        color: 'var(--status-error)',
        fontSize: 'var(--fs-caption)',
        marginTop: 'var(--sp-3)',
        minHeight: '20px',
    });
    form.append(errBox);
    card.append(form);
    layout.append(card);
    screen.append(layout);
    // ——— Davranış: mevcut akışın aynısı ———
    const forgot = form.querySelector('#forgot');
    forgot.addEventListener('click', async (ev) => {
        ev.preventDefault();
        const email = form.querySelector('#email').value.trim();
        if (!email) {
            alert('E-posta adresini gir, parola sıfırlama linki gönderilecek.');
            return;
        }
        try {
            await appState.backend.requestPasswordReset(email);
            alert('Parola sıfırlama e-postası gönderildi (hesap varsa).');
        }
        catch (e) {
            alert(`İstek başarısız: ${e}`);
        }
    });
    (async () => {
        try {
            const providers = await appState.backend.listSsoProviders();
            if (providers.length === 0)
                return;
            ssoBox.innerHTML = `<div style="font-size:var(--fs-caption);color:var(--text-tertiary);margin-bottom:8px;display:flex;align-items:center;gap:8px">
        <span style="flex:1;height:1px;background:var(--border-subtle)"></span>
        <span style="letter-spacing:0.12em">veya şirket hesabıyla</span>
        <span style="flex:1;height:1px;background:var(--border-subtle)"></span>
      </div>`;
            const row = document.createElement('div');
            applyStyle(row, { display: 'flex', flexWrap: 'wrap', gap: 'var(--sp-2)' });
            for (const p of providers) {
                const btn = createButton({
                    label: p.name,
                    variant: 'ghost',
                    iconHtml: icons.shield(),
                    onClick: () => {
                        if (p.authorizationUrl)
                            window.location.href = p.authorizationUrl;
                    },
                });
                row.append(btn);
            }
            ssoBox.append(row);
        }
        catch {
            // SSO endpoint yok — sessiz geç
        }
    })();
    submit.addEventListener('click', async (ev) => {
        ev.preventDefault();
        errBox.textContent = '';
        submit.disabled = true;
        try {
            const url = (form.querySelector('#url')).value.trim();
            const email = (form.querySelector('#email')).value.trim().toLowerCase();
            const password = (form.querySelector('#password')).value;
            if (!email || !password) {
                errBox.textContent = 'E-posta ve şifre gerekli.';
                return;
            }
            appState.setBackendUrl(url);
            try {
                await appState.login(email, password);
            }
            catch (loginErr) {
                const msg = String(loginErr);
                if (msg.includes('429')) {
                    errBox.textContent = 'Çok deneme oldu — 60 saniye bekleyip tekrar deneyin.';
                }
                else if (msg.includes('401')) {
                    errBox.textContent = 'E-posta veya şifre hatalı. (Tarayıcı yanlışlıkla ilk harfi büyük yazmış olabilir.)';
                }
                else {
                    errBox.textContent = msg;
                }
            }
        }
        catch (e) {
            errBox.textContent = String(e);
        }
        finally {
            submit.disabled = false;
        }
    });
    passkey.addEventListener('click', async (ev) => {
        ev.preventDefault();
        errBox.textContent = '';
        passkey.disabled = true;
        try {
            const url = (form.querySelector('#url')).value.trim();
            const email = (form.querySelector('#email')).value.trim();
            if (!email) {
                errBox.textContent = 'E-posta gir, sonra donanım anahtarla giriş yap.';
                return;
            }
            appState.setBackendUrl(url);
            const optsJson = await appState.backend.webauthnLoginBegin(email);
            const opts = decodeAssertionOptions(optsJson);
            const cred = (await navigator.credentials.get({ publicKey: opts }));
            if (!cred) {
                errBox.textContent = 'İptal edildi.';
                return;
            }
            const auth = await appState.backend.webauthnLoginFinish(optsJson, encodeAssertionResponse(cred));
            appState.finishWebAuthnLogin(auth);
        }
        catch (e) {
            errBox.textContent = `Passkey giriş hatası: ${e.message ?? e}`;
        }
        finally {
            passkey.disabled = false;
        }
    });
    // Dar ekranlar — tek kolon
    const mq = window.matchMedia('(max-width: 880px)');
    const apply = () => {
        layout.style.gridTemplateColumns = mq.matches
            ? 'minmax(0, 480px)'
            : 'minmax(0, 480px) minmax(0, 480px)';
    };
    apply();
    mq.addEventListener('change', apply);
    return screen;
}
function escapeAttr(s) {
    return s.replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
}
